
$('.banner-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,              // Enable auto scroll
  autoplaySpeed: 3000,         // Scroll every 5 seconds
  arrows: true,
  dots: true,
});

$('.cd-collection-list-slider').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  arrows: true,
  dots: false,
   responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
  
});
$('.cd-product-slider ').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  arrows: false,
  dots: true,
   responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
  
});
$('.testi-slider ').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  arrows: true,
  dots: false,
   responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
  
});
$('.marquee-slider').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  arrows: true,
  dots: false,
   responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
  
});
$(document).ready(function(){
  $(".cd-filter-tab").click(function(){
    $(".cd-filter-collection").toggleClass("open");
  });
});


//
$(document).ready(function() {
    $('.terms-relentless a').on('click', function(event) {
        event.preventDefault(); // Prevent the default link behavior
        $('#modal').fadeIn(); // Show the modal with fade-in effect
    });

    $('#closeModal').on('click', function() {
        $('#modal').fadeOut(); // Hide the modal with fade-out effect
    });

    $(window).on('click', function(event) {
        if ($(event.target).is('#modal')) {
            $('#modal').fadeOut(); // Hide the modal if clicking outside
        }
    });

});

  // Wait for the document to be fully loaded
document.addEventListener('DOMContentLoaded', function() {
    // Set a timeout to add the 'active' class after 2000 milliseconds (2 seconds)
    setTimeout(function() {
        // Select the element with the class 'loader-mask' and add the class 'active'
        var loaderMask = document.querySelector('.loader-mask');
        if (loaderMask) {
            loaderMask.classList.add('active');
        }
    }, 2000);
});


  let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  console.log(items)
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  
  });


document.getElementById("ContactForm-phone").addEventListener("input", function() {
    let phoneInput = this.value;
    let errorMessage = document.getElementById("phone-error");
    let submitButton = document.getElementById("submit-btn");

    // Remove non-numeric characters
    this.value = phoneInput.replace(/\D/g, '');

    // Check if the phone number is exactly 10 digits
    if (this.value.length !== 10) {
        errorMessage.style.display = "block";
        errorMessage.textContent = "Phone number must be exactly 10 digits.";
        submitButton.disabled = true;
    } else {
        errorMessage.style.display = "none";
        submitButton.disabled = false;
    }
});

























